import { render } from "./ServicesManager.vue?vue&type=template&id=bf6324c4&scoped=true"
import script from "./ServicesManager.vue?vue&type=script&lang=js"
export * from "./ServicesManager.vue?vue&type=script&lang=js"

import "./ServicesManager.vue?vue&type=style&index=0&id=bf6324c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6324c4"]])

export default __exports__